import React from 'react';
import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { persistUserLanguage } from '../services/api';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
    persistUserLanguage(lng);
  };

  const handleLanguageChange = (event: SelectChangeEvent<string>) => {
    changeLanguage(event.target.value);
  };

  const languageCode = (i18n.language || 'nl').split('-')[0];
  const currentLanguage = ['bg', 'en', 'nl', 'tr', 'pl'].includes(languageCode)
    ? languageCode
    : 'nl';

  return (
    <FormControl size="small" variant="standard" sx={{ minWidth: 58 }}>
      <Select
        value={currentLanguage}
        onChange={handleLanguageChange}
        disableUnderline
        sx={{
          color: 'white',
          fontSize: '0.875rem',
          '& .MuiSelect-select': {
            py: 0.25,
            px: 0.5,
          },
          '& .MuiSelect-icon': {
            color: 'white',
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: { minWidth: 80 },
          },
        }}
      >
        <MenuItem value="bg">BG</MenuItem>
        <MenuItem value="en">EN</MenuItem>
        <MenuItem value="nl">NL</MenuItem>
        <MenuItem value="tr">TR</MenuItem>
        <MenuItem value="pl">PL</MenuItem>
      </Select>
    </FormControl>
  );
};

export default LanguageSwitcher; 